import React, { Suspense, lazy } from 'react';
import { Hero } from './components/sections/Hero';
import { SocialProof } from './components/sections/SocialProof';
import { Pain } from './components/sections/Pain';
import { MidCTA } from './components/sections/MidCTA';
import { MetaPixel } from './components/MetaPixel';
// Lazy load below-fold sections to speed up initial render
const ProductIntro = lazy(() => import('./components/sections/ProductIntro').then(m => ({
  default: m.ProductIntro
})));
const Tomos = lazy(() => import('./components/sections/Tomos').then(m => ({
  default: m.Tomos
})));
const Bonus = lazy(() => import('./components/sections/Bonus').then(m => ({
  default: m.Bonus
})));
const PricingSection = lazy(() => import('./components/sections/PricingSection').then(m => ({
  default: m.PricingSection
})));
const Comparison = lazy(() => import('./components/sections/Comparison').then(m => ({
  default: m.Comparison
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/sections/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
const SectionFallback = () => <div className="py-20" aria-hidden="true" data-id="element-0" />;
export function App() {
  return <div className="min-h-screen font-sans bg-hueso text-oscuro selection:bg-terracota/30" data-id="element-1">
      <MetaPixel data-id="element-2" />
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />
      <Pain data-id="element-5" />
      <MidCTA data-id="element-6" />

      <Suspense fallback={<SectionFallback data-id="element-8" />} data-id="element-7">
        <ProductIntro data-id="element-9" />
        <Tomos data-id="element-10" />
        <Bonus data-id="element-11" />
        <PricingSection id="precios" data-id="element-12" />
        <Comparison data-id="element-13" />
        <Testimonials data-id="element-14" />
        <Guarantee data-id="element-15" />
        <FAQ data-id="element-16" />
        <Footer data-id="element-17" />
        <PurchasePopup data-id="element-18" />
      </Suspense>
    </div>;
}